import { render, staticRenderFns } from "./TabAtendimento.vue?vue&type=template&id=13079508"
import script from "./TabAtendimento.vue?vue&type=script&lang=ts"
export * from "./TabAtendimento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports